import { createSlice } from '@reduxjs/toolkit';

const initialState={
    location:null
}
export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {

    setLocation: (state, action) => {
      state.location = action.payload;
      
      
    },
    setLogoutLocation: (state,action)=>{
      state.location=null
    }
  },
});
export const {  setLocation,setLogoutLocation} = locationSlice.actions;

export default locationSlice.reducer;
